





import {
  defineComponent,
} from '@vue/composition-api';

import PageColumnWithCustomerEditor from '@/components/Customer/PageColumnWithCustomerEditor.vue';

const Create = defineComponent({
  // setup() {},
  components: {
    PageColumnWithCustomerEditor,
  },
});

export default Create;
